import SafeImage from '@ui/SafeImage';
import type { OrderItemDocument } from 'models/order';
import type { ProductLight } from 'models/product';
import { FavoriteButton } from '../MXProductCard/FavoriteButton';
import { ListSoldOutOverlay } from './ListSoldOutOverlay';

export const ListProductPicture = ({
  product,
  attribution,
  setAttribution,
}: {
  product: ProductLight;
  attribution?: OrderItemDocument['attribution'];
  setAttribution: (
    id: string,
    attribution: OrderItemDocument['attribution']
  ) => void;
}) => {
  return (
    <div
      className={`relative my-auto min-h-[15rem] min-w-[15rem] sm:h-[25rem] sm:w-[25rem] ${
        product.integration_info ? 'rounded-2xl bg-white' : ''
      }`}
    >
      <SafeImage
        src={product.thumbnail}
        alt={`Product image for - ${product.title}`}
        fill
        className={`bg-repeat ${
          product.seller_id === 'E16WuBcn0UMejlp0FSdQulSSed12' ||
          product.integration_info
            ? 'object-contain'
            : 'object-cover'
        }`}
      />
      {product.out_of_stock && !product.is_auction && <ListSoldOutOverlay />}

      <div className="absolute right-[1rem] top-[1rem] flex w-full justify-end sm:right-[1rem]">
        <FavoriteButton
          product={product}
          initialCount={product.favorite_count}
        />
      </div>
    </div>
  );
};
